import {
    UI_CONTEXT_COACH_AUDIO,
    UI_CONTEXT_REVIEW_LESSON_AUDIO,
    UI_CONTEXT_REVIEW_PREVIOUS_MATERIAL_AUDIO,
    type AudioUiContext,
    type CoachAudioUiContext,
} from 'TutorBotConversation';
import { type ReviewPreviousMaterialVoiceAgentUiContext } from '../TutorBotVoiceAgent.types';

export function isReviewPreviousMaterialAudioUiContext(
    uiContext: AudioUiContext,
): uiContext is ReviewPreviousMaterialVoiceAgentUiContext {
    return uiContext === UI_CONTEXT_REVIEW_PREVIOUS_MATERIAL_AUDIO || uiContext === UI_CONTEXT_REVIEW_LESSON_AUDIO;
}

export function isCoachAudioUiContext(uiContext: AudioUiContext): uiContext is CoachAudioUiContext {
    return uiContext === UI_CONTEXT_COACH_AUDIO;
}
